<flx-status
  [label]="displayValue()"
  [severity]="statusSeverity()"
  [deprecated]="deprecated()"
  data-testid="status-cell"
/>
